import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RepomixExplorer from '../components/RepomixExplorer';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileUnsupported from '@/components/MobileUnsupported';

const RepomixExplorerPage: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 flex flex-col">
        <div className="flex-1 flex flex-col mx-auto w-full max-w-[1400px] p-4">
          {isMobile ? (
            <React.Suspense fallback={<div className="p-8 text-center">Loading mobile view...</div>}>
              <MobileUnsupported 
                title="Repomix Explorer - Desktop Recommended"
                description="The codebase exploration tools are optimized for desktop browsers. Please open beaUX on a desktop computer for the full interactive experience."
              />
            </React.Suspense>
          ) : (
            <RepomixExplorer />
          )}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default RepomixExplorerPage;